import { getStyles } from '@kubit/web-ui-components/utils/getStyles';
import styled from 'styled-components';
export const ParentContainer = styled.button `
  ${props => getStyles(props.styles?.container)}
  &> * {
    vertical-align: middle;
  }
`;
//# sourceMappingURL=iconButton.styled.js.map